// Common English translations
export const commonEn = {
  'action': 'Action',
  'actions': 'Actions',
  'active': 'Active',
  'add.by.image': 'Add by Image',
  'add.manually': 'Add Manually',
  'address': 'Address',
  'admin': 'Admin',
  'affected.date': 'Affected Date',
  'all': 'All',
  'all.actions': 'All Actions',
  'all.capacities': 'All Capacities',
  'all.records': 'All Records',
  'all.types': 'All Types',
  'amount': 'Amount',
  'april': 'April',
  'attach.receipt': 'Attach Receipt (Optional)',
  'august': 'August',
  'average': 'Average',
  'average.efficiency': 'Average Efficiency',
  'back': 'Back',
  'back.to.dashboard': 'Back to Dashboard',
  'best': 'Best',
  'best.efficiency': 'Best Efficiency',
  'brand': 'Brand',
  'calculate.l.per.100km': 'Calculate L/100km',
  'cancel': 'Cancel',
  'cannot.delete.selected.model': 'Cannot delete the currently selected model',
  'change': 'Change',
  'change.date': 'Change Date',
  'changed.by': 'Changed By',
  'clear': 'Clear',
  'click.save.to.store': 'Click "Save" button in the Actions column to save individual documents as drafts.',
  'close': 'Close',
  'color': 'Color',
  'company.name': 'Company Name',
  'confirm.delete': 'Confirm Delete',
  'confirm.password': 'Confirm Password',
  'confirm.restore.record': 'Are you sure you want to restore this record?',
  'cost': 'Cost',
  'create': 'Create',
  'created': 'Created',
  'created.at': 'Created At',
  'created.by': 'Created By',
  'created.receipts': 'Created Receipts',
  'created.records': 'Created Records',
  'current.file': 'Current File',
  'current.image': 'Current Image',
  'current.tax.rate': 'Current Tax Rate',
  'currently.processing': 'Currently processing',
  'dashboard': 'Dashboard',
  'date': 'Date',
  'date.of.birth': 'Date of Birth',
  'date.range': 'Date Range',
  'date.range.label': 'Date Range',
  'december': 'December',
  'default.admin.info': 'Default admin: username = "admin", password = "admin123"',
  'delete': 'Delete',
  'delete.confirm': 'Are you sure you want to delete this item?',
  'delete.current.file.confirm': 'Are you sure you want to delete the current file?',
  'delete.file': 'Delete File',
  'deleted': 'Deleted',
  'deleted.at': 'Deleted At',
  'deleted.by': 'Deleted By',
  'deleted.records': 'Deleted Records',
  'description': 'Description',
  'destination': 'Destination',
  'destinationProvince': 'Province',
  'distance': 'Distance',
  'district': 'District',
  'district.list': 'District List',
  'district.management': 'District Management',
  'draft': 'Draft',
  'draft.receipts': 'Draft Receipts',
  'edit': 'Edit',
  'effective.date': 'Effective Date',
  'efficiency': 'Efficiency',
  'efficiency.trend': 'Efficiency Trend',
  'emergency.contact': 'Emergency Contact',
  'enter.description': 'Enter description',
  'enter.model.name': 'Enter model name',
  'error.fetching.data': 'Error fetching data',
  'expiry.date': 'Expiry Date',
  'export.all.data': 'Export All Data',
  'export.data': 'Export Data',
  'export.description': 'Download all system data as a JSON file',
  'export.error': 'Error exporting data',
  'export.success': 'Data exported successfully',
  'export.to.excel': 'Export to Excel',
  'exporting': 'Exporting',
  'february': 'February',
  'file.deleted.successfully': 'File deleted successfully',
  'file.name': 'File Name',
  'file.processed.successfully': 'File processed successfully',
  'file.ready': 'File ready',
  'file.too.large': 'File is too large. Maximum size is 10MB.',
  'files.processed.sequentially': 'Files are processed one by one to ensure stability. Please wait for all files to complete.',
  'files.selected': 'file(s) selected',
  'filter.by.link.status': 'Filter by Link Status',
  'filters': 'Filters',
  'finalize': 'Finalize',
  'first.name': 'First Name',
  'found.matches': 'Found Matches',
  'from.date': 'From Date',
  'from.to': 'From - To',
  'history': 'History',
  'image.processed.successfully': 'Image processed successfully',
  'import.data': 'Import Data',
  'import.description': 'Upload a JSON file to import data into the system',
  'import.error': 'Error importing data',
  'import.success': 'Data imported successfully',
  'importing': 'Importing',
  'inactive': 'Inactive',
  'insurance.expiry': 'Insurance Expiry',
  'invalid.file.type': 'Invalid file type. Please upload an image or PDF file.',
  'is.active': 'Is Active',
  'january': 'January',
  'july': 'July',
  'june': 'June',
  'language': 'Language',
  'last.30.days': 'Last 30 Days',
  'last.30.days.records': 'Last 30 days records',
  'last.60.days': 'Last 60 Days',
  'last.90.days': 'Last 90 Days',
  'last.name': 'Last Name',
  'last.update': 'Last Update',
  'leave.empty.for.all.capacities': 'Leave empty to apply to all vehicle capacities',
  'legend': 'Legend',
  'license.expiry': 'License Expiry',
  'license.number': 'License Number',
  'link': 'Link',
  'link.status': 'Link Status',
  'linked': 'Linked',
  'linked.records': 'Linked Records',
  'location': 'Location',
  'location.type': 'Location Type',
  'logging.in': 'Logging in...',
  'login': 'Login',
  'logout': 'Logout',
  'march': 'March',
  'mark.as.created': 'Mark as Created',
  'may': 'May',
  'message': 'Message',
  'mode.save.description': 'Process documents, extract data, and automatically save as draft records (WaitForProcess/Pending state) for later review',
  'mode.view.description': 'Process documents and view extracted data without saving to database. You can save individual documents later.',
  'model': 'Model',
  'model.description': 'Description',
  'model.name': 'Model Name',
  'more': 'more',
  'more.districts': 'more',
  'moving': 'Moving',
  'n.a': 'N/A',
  'name': 'Name',
  'no': 'No',
  'no.data': 'No data',
  'no.data.for.date': 'No data available for this date',
  'no.deleted.records': 'No deleted records found',
  'no.description': 'No Description',
  'no.districts.applies.to.all': 'No districts (applies to all)',
  'no.districts.selected': 'No districts selected - RM2 will apply to shipping destinations NOT in any district list',
  'no.efficiency.data': 'No fuel efficiency data available',
  'no.file.selected': 'No file selected',
  'no.image': 'No Image',
  'no.position': 'No Position',
  'no.position.data': 'No position data available',
  'no.records.match.filters': 'No records match filters',
  'notes': 'Notes',
  'november': 'November',
  'october': 'October',
  'overall.statistics': 'Overall Statistics',
  'password': 'Password',
  'periods': 'Periods',
  'phone': 'Phone',
  'please.enter.valid.total': 'Please enter valid total amount',
  'please.input': 'Please input',
  'please.provide.reason.for.change': 'Please provide a reason for the change',
  'please.save.record.first': 'Please save the record first',
  'please.select': 'Please select',
  'please.select.date.range': 'Please select a date range',
  'please.select.language': 'Please select a language',
  'pricing': 'Pricing',
  'process.and.save.drafts': 'Process & Save as Drafts',
  'process.and.view': 'Process & View',
  'processed.data': 'Processed Data',
  'processed.files': 'Processed Files',
  'processing': 'Processing',
  'processing.complete': 'Processing Complete',
  'processing.in.progress': 'Processing in Progress',
  'processing.note': 'Note',
  'processing.records': 'Processing Records',
  'province': 'Province',
  'province.filter': 'Province Filter',
  'rate': 'Rate',
  'rate.percentage': 'Rate (%)',
  'rate.validation.message': 'Rate must be between 0 and 1 (e.g., 0.045 for 4.5%)',
  'raw.processed.data': 'Raw Processed Data',
  'reason': 'Reason',
  'reason.for': 'Reason for',
  'receipt.image': 'Receipt Image',
  'receipt.image.processing': 'Receipt Image Processing',
  'recent.shipments': 'Recent Shipments',
  'record.restored.successfully': 'Record restored successfully',
  'record.saved.pending': 'Record saved as pending.',
  'record.saved.successfully': 'Record saved successfully as draft',
  'records.saved.as.drafts': 'Records have been saved as drafts. You can review and finalize them later.',
  'refresh': 'Refresh',
  'registration.expiry': 'Registration Expiry',
  'remove': 'Remove',
  'required.field': 'This field is required',
  'restore': 'Restore',
  'results': 'Results',
  'retry': 'Retry',
  'retrying': 'Retrying',
  'revenue': 'Revenue',
  'review.finalize.below': 'Review and finalize below',
  'route': 'Route',
  'save': 'Save',
  'save.as.draft': 'Save as Draft',
  'saved': 'Saved',
  'saving': 'Saving',
  'search': 'Search',
  'select.date': 'Select Date',
  'select.district': 'Select District',
  'select.import.file': 'Select Import File',
  'select.model': 'Select',
  'select.province': 'Select Province',
  'select.province.to.filter.districts': 'Select province to filter districts',
  'select.timezone': 'Select timezone',
  'selected.districts': 'Selected Districts',
  'selected.files': 'Selected Files',
  'selected.model': 'Selected Model',
  'september': 'September',
  'shop': 'Shop',
  'showing.results': 'Showing {start} to {end} of {total} results',
  'speed': 'Speed',
  'status': 'Status',
  'stopped': 'Stopped',
  'success.created': 'Fee structure created successfully',
  'success.deleted': 'Fee structure deleted successfully',
  'success.updated': 'Fee structure updated successfully',
  'successful': 'Successful',
  'sync': 'Sync',
  'tax': 'Tax',
  'tax.rate': 'Tax Rate',
  'theme': 'Theme',
  'theme.dark': 'Dark',
  'theme.light': 'Light',
  'time': 'Time',
  'time.period': 'Time Period',
  'timezone': 'Timezone',
  'to.date': 'To Date',
  'to.draft': 'To Draft',
  'tons': 'tons',
  'total': 'TOTAL',
  'total.amount': 'Total Amount',
  'total.costs': 'Total Costs',
  'total.distance': 'Total Distance',
  'total.files': 'Total Files',
  'total.records': 'Total Records',
  'total.shipments': 'Total Shipments',
  'tps.logistics.login': 'TPS Logistics Login',
  'trips': 'Trips',
  'two.processing.modes': 'Two Processing Modes',
  'type': 'Type',
  'unknown': 'Unknown',
  'unknown.station': 'Unknown Station',
  'unlink': 'Unlink',
  'unlinked': 'Unlinked',
  'unlinked.records': 'Unlinked Records',
  'update': 'Update',
  'update.receipt': 'Update Receipt',
  'update.tax.rate': 'Update Tax Rate',
  'updated': 'Updated',
  'view': 'View',
  'view.all': 'View All',
  'view.current.file': 'View Current File',
  'view.current.image': 'View Current Image',
  'view.image': 'View Image',
  'view.records': 'View Records',
  'welcome.back': 'Welcome back',
  'worst': 'Worst',
  'worst.efficiency': 'Worst Efficiency',
  'year': 'Year',
  'yes': 'Yes',
  'yes.delete': 'Yes, Delete',

  // Job History / Processing History
  'processing.history': 'Processing History',
  'no.jobs.found': 'No processing jobs found for the selected filters.',
  'completed': 'Completed',
  'failed': 'Failed',
  'source': 'Source',
  'days': 'Days',
  'apply': 'Apply',
  'reset': 'Reset',
  'completed.at': 'Completed At',
  'processing.time': 'Processing Time',
  'error.reason': 'Error / Reason',
  'all.sources': 'All Sources',
  'all.statuses': 'All Statuses',
  'no.retry.available': 'No retry available',
  'confirm.delete.job': 'Delete job for "{fileName}"?',
};
